import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

// Lazy load all page components for better performance
const AboutPage = lazy(() => import("../pages/AboutPage"));
const AboutusPage = lazy(() => import("../pages/AboutusPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const HomePage = lazy(() => import("../pages/HomePage"));
const ProductDetailsPage = lazy(() => import("../pages/ProductDetailsPage"));
const ContactusPage = lazy(() => import("../pages/ContactusPage"));
const GaleriPage = lazy(() => import("../pages/GaleriPage"));
const SidebarPage = lazy(() => import("../pages/SidebarPage"));
const CommentsPage = lazy(() => import("../pages/CommentsPage"));
const PortfolioPage = lazy(() => import("../pages/PortfolioPage"));
const OtherPagePage = lazy(() => import("../pages/OtherPagePage"));
const EvolutionPage = lazy(() => import("../pages/EvolutionPage"));
const ProductsPage = lazy(() => import("../pages/ProductsPage"));
const DynamicPage = lazy(() => import("../pages/DynamicPage"));
const EducationPage = lazy(() => import("../pages/EducationPage"));
const ProPage = lazy(() => import("../pages/ProPage"));
/* const TopBarPage = lazy(() => import("../pages/TopBarPage")); */

const CustomRoutes = () => {
  return (
    <Routes>
    <Route exact path="/kazanimlarimiz" element={<EducationPage />} />
      <Route exact path="/dinamiklerimiz" element={<DynamicPage />} />
      <Route exact path="/etkinliklerimiz" element={<ProPage />} />
      <Route exact path="/gelisim-alanlarimiz" element={<EvolutionPage />} />
      <Route
        exact
        path="/velilerimizin-gorusleri"
        element={<OtherPagePage />}
      />
      <Route exact path="/ailemiz" element={<PortfolioPage />} />
      <Route exact path="/Comments" element={<CommentsPage />} />
      <Route exact path="/Sidebar" element={<SidebarPage />} />
      <Route exact path="/galeri" element={<GaleriPage />} />
      <Route path="/iletisim" element={<ContactusPage />} />
      <Route exact path="/detay" element={<ProductDetailsPage />} />
      {/* <Route exact path="/TopBar" element={<TopBarPage />} /> */}
      <Route exact path="/etkinliklerimiz" element={<ProductsPage />} />
      <Route path="/iletisim" element={<ContactPage />} />
      <Route path="/hakkimizda" element={<AboutusPage />} />
      <Route path="/hakkimizda" element={<AboutPage />} />
      <Route path="/" element={<HomePage />} />
    </Routes>
  );
};

export default CustomRoutes;
